import { styled } from "@vitality-ds/system";
import BaseSortedIconContainerStyles from "./styles/BaseSortedIconContainer";

// eslint-disable-next-line import/prefer-default-export
export var BaseSortedIconContainer = styled("div", BaseSortedIconContainerStyles);